import React, {useState} from "react";
import axios from "axios";
import {setUserSession} from '../Utils/Security';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './Login.css';
import {useHistory} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";
import PropTypes from 'prop-types';
import CustomAlert from "./CustomAlert";

function Login({ setAuthenticated }) {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [validated, setValidated] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const history = useHistory();

    function handleSubmit(event) {
        reset();
        setValidated(true);
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            return;
        }
        axios.post("/api/login", {
            'username': username,
            'password': password
        }).then(resp => {
            setUserSession(resp.headers['x-auth-token'], resp.data);
            setAuthenticated(true);
            history.push('/dashboard');
        }).catch(function (error) {
            setHasError(true);
            let errorMessage = error.response && error.response.data ? error.response.data : 'Something went wrong. Please try again'
            setErrorMessage(errorMessage);
        });
    }

    function reset() {
        setHasError(false);
        setErrorMessage(null);
    }

    const renderError = () => {
        if (hasError) {
            return <CustomAlert variant={'danger'} message={errorMessage}/>;
        }
    };

    const register = () => {
        history.push('/register');
    }

    return (
        <Container>
            <Form noValidate
                  validated={validated}
                  className="mt-4 mb-5"
                  onSubmit={handleSubmit}>

                <h2 className="mt-4 mb-5">Login</h2>

                <Row>
                    <Col>
                        <Form.Group controlId="validationUsername">
                            <Form.Label>Username</Form.Label>
                            <Form.Control type="text" placeholder="Username"
                                          onChange={(e) => setUsername(e.target.value)}
                                          required/>
                            <Form.Control.Feedback type="invalid">
                                Please choose a username
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Group md="12" controlId="validationPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Password"
                                          onChange={(e) => setPassword(e.target.value)}
                                          required/>
                            <Form.Control.Feedback type="invalid">
                                Please choose a password
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Button block md="12" type="submit">Submit</Button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {renderError()}
                        <div className="register-user">
                            <a href="" onClick={register}>Register User</a>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Container>

    )
}

export default Login;

Login.propTypes = {
    setAuthenticated: PropTypes.func.isRequired
}